var moduleMap = {
	"./Assistant": function() {
		return Promise.all([__webpack_require__.e(432), __webpack_require__.e(242), __webpack_require__.e(613), __webpack_require__.e(618), __webpack_require__.e(926), __webpack_require__.e(620), __webpack_require__.e(469), __webpack_require__.e(582), __webpack_require__.e(692), __webpack_require__.e(991)]).then(function() { return function() { return (__webpack_require__(6618)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});